<template>
    <div v-if="visibleActions.length > 0"
         class="btn-group btn-group-action"
         role="group"
         aria-label="Default action">
        <button v-for="(action, index) in visibleActions"
                :key="index"
                type="button"
                class="btn"
                :class="action.className ? action.className : (action.disabled && action.disabled(rowData)) ? '' : 'btn-success'"
                data-toggle="tooltip"
                data-placement="top"
                :title="action.title"
                :disabled="action.disabled && action.disabled(rowData)"
                @click.prevent="callMethod('',action)">
            <app-icon v-if="action.icon" :name="action.icon"/>
            <span v-else>
                {{ action.title }}
            </span>
        </button>
    </div>
    <div v-else-if="columnType === 'detail-usages-deductions'"
         class="btn-group btn-group-action"
         role="group"
         aria-label="Default action">
        <button
                type="button"
                class="btn"
                :title="columnTitle"
                @click.prevent="callMethod('',{type: `${columnType}`, title: `${columnType}`})">
            <span v-html="uniqueKey">
            </span>
        </button>
    </div>
    <div v-else-if="columnType === 'absen'"
         aria-label="Default action">
        <input type="checkbox" :checked="this.absenChecked" @change="handleAbsenCheckboxChange" v-model="isAbsenChecked" />
    </div>
    <div v-else-if="columnType === 'absen-readonly'"
         aria-label="Default action">
        <input type="checkbox" :checked="this.absenChecked" v-model="isAbsenChecked" disabled />
    </div>
</template>

<script>
import {ActionMixin} from "./mixin/ActionMixin.js";

export default {
    name: "DefaultAction",
    mixins: [ActionMixin],
    mounted() {
        setTimeout(() => {
            $('[data-toggle="tooltip"]').tooltip()
        }, 3000);
    },
}
</script>
